import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { UserType } from 'lib-shared-types-api';
import { Field } from 'redux-form';

import { FieldRadio } from 'fable/fieldRadio';
import { userTypeAssets } from 'utils/user';

import styles from './userTypeField.module.scss';

/** Represents the user types that can be updated. */
const updateableUserTypes: UserType[] = ['contact', 'member'];

/** Represents the redux-form field component to update the user type. */
export const UserTypeField = (): JSX.Element => {
  return (
    <FlexBox alignItems="center" gap="200" flex="1">
      {updateableUserTypes.map((userType) => (
        <label key={userType} htmlFor={userType} className={styles.radioLabel}>
          <Field
            type="radio"
            name="user_type"
            id={userType}
            value={userType}
            component={FieldRadio}
          />

          <Text.Paragraph as="span">
            {userTypeAssets[userType].prettyName}
          </Text.Paragraph>
        </label>
      ))}
    </FlexBox>
  );
};
